import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import { useAttributeSelected } from "../AttributeSelectedProvider/AttributeSelectedProvider";
import { GraphNode } from "../../../utils";
import styles from "./AttributeName.module.scss";

export interface AttributeNameProps {
  node: GraphNode;
  className?: string;
}

const DefaultAttributeName = (props: AttributeNameProps) => {
  const { node, className } = props;
  const selected = useAttributeSelected();

  if (!node) return null;

  const clickable = Boolean(selected?.onSelectAttribute);

  let name = node.description;
  if (node.validation) {
    name = `(${node.validation.severity}) ${node.validation.message}`;
  }

  return (
    <span
      className={clsx(styles.attributeName, className)}
      data-deci-attribute-name="true"
      data-clickable={clickable ? "true" : "false"}
      data-hidden={node.hidden ? "true" : "false"}
      onClick={() => clickable && selected?.onSelectAttribute?.(node)}
    >
      {name}
    </span>
  );
};

const AttributeName = createPluggable<AttributeNameProps>("deci.attributeName", DefaultAttributeName);

export default AttributeName;
